import { FC } from 'react';

import { PLAN_CARD_TEST_ID } from '../constants';
import { isDownloadLink, PlanCardModel } from '../model';
import { ContractSummaryWrapper, SmallerLink } from '../PlanCard.styles';

type Props = { contractSummary: PlanCardModel.ContractSummaryType } & PlanCardModel.NegativeProp;

export const ContractSummary: FC<Props> = ({ contractSummary, isNegative }) => {
    if (!contractSummary) {
        return null;
    }
    if (isDownloadLink(contractSummary)) {
        return (
            <ContractSummaryWrapper data-test={PLAN_CARD_TEST_ID.CONTRACT_SUMMARY}>
                <SmallerLink
                    href={contractSummary.href}
                    download={contractSummary.download}
                    negative={isNegative}
                    variant="text"
                    disableVisited={false}
                    target="_blank"
                    rel="noreferrer"
                >
                    {contractSummary.text}
                </SmallerLink>
            </ContractSummaryWrapper>
        );
    }

    const CustomComponent = contractSummary;

    return (
        <ContractSummaryWrapper data-test={PLAN_CARD_TEST_ID.CONTRACT_SUMMARY}>
            <CustomComponent isNegative={isNegative} />
        </ContractSummaryWrapper>
    );
};
